import React from "react";

const ADO_DataTypes = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO DataTypes</h1>
      <p>This is the ADO DataTypes page content.</p>
    </div>
  );
};

export default ADO_DataTypes;
